// extracted by mini-css-extract-plugin
module.exports = {"infowindow":"Infowindow_infowindow__2ka00","name":"Infowindow_name__3eiVc","loading":"Infowindow_loading__6p1DA"};